import React, { useState, useEffect, useCallback } from "react";
import Slider from "react-slick";
import { Loader, Message, Icon } from "semantic-ui-react";
import { DidacticRoutesAPI } from "../../../../api";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./ScenesPanel.scss";

const didacticRoutesAPI = new DidacticRoutesAPI();

const CIRCLE_COLOR_MAP = {
  "CIENCIAS HUMANAS":    "circle--ciencias-humanas",
  "CIENCIAS NATURALES":  "circle--ciencias-naturales",
  HISTORIA:              "circle--historia",
  MATEMATICAS:           "circle--matematicas",
  ARTE:                  "circle--arte",
  "VIDA SALUDABLE":      "circle--vida-saludable",
  OTROS:                 "circle--gray",
};

function normalizeCategory(cat) {
  return cat
    .trim()
    .toUpperCase()
    .replace(/Á/g, "A")
    .replace(/É/g, "E")
    .replace(/Í/g, "I")
    .replace(/Ó/g, "O")
    .replace(/Ú/g, "U");
}

function getCircleColorClass(cat) {
  return CIRCLE_COLOR_MAP[normalizeCategory(cat)] || "circle--gray";
}

export function ScenesPanel({ routeId, accessToken, onEnterScene }) {
  const [scenes, setScenes]   = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);

  const fetchScenes = useCallback(async () => {
    if (!routeId) return;
    try {
      setLoading(true);
      setError(null);
      const result = await didacticRoutesAPI.getScenesByRoute(
        accessToken,
        routeId,
        1,
        50
      );
      setScenes(result.scenes || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [accessToken, routeId]);

  useEffect(() => {
    fetchScenes();
  }, [fetchScenes]);

  
  if (loading) {
    return <Loader active inline="centered">Cargando escenas.</Loader>;
  }
  if (error) {
    return (
      <Message negative>
        <Message.Header>Error cargando escenas</Message.Header>
        <p>{error}</p>
      </Message>
    );
  } 
  /*if (!scenes.length) {
    return (
      <Message info>
        <Message.Header>Selecciona un Itinerario</Message.Header>
        <p>Aparecerán las clases asignadas a ese Itinerario, si no aparecen, ve al apartado "Crear itinerarios y añade clases a tu Itinerario".</p>
        <p>Si no tienes Itinerarios creados, ve al apartado "Crear itinerarios" y crea uno.</p>
      </Message>
    );
  }*/

  const handleEnter = (scene) => {
    if (onEnterScene) onEnterScene(scene);
    else window.open(scene.urlsala, "_blank", "noopener,noreferrer");
  };

  // Dinámica según número de escenas
  const slidesToShow = Math.min(scenes.length, 4);
  const infinite     = scenes.length > slidesToShow;

  const settings = {
    dots: true,
    infinite,
    slidesToShow,
    slidesToScroll: 1,
    speed: 500,
    swipeToSlide: true,    // arrastrar entre slides
    edgeFriction: 1,       // sin rebote elástico al llegar al extremo
    adaptiveHeight: true,  
    responsive: [
      {
        breakpoint: 1594,
        settings: {
          slidesToShow: Math.min(scenes.length, 3),
          infinite: scenes.length > 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1286,
        settings: {
          slidesToShow: Math.min(scenes.length, 2),
          infinite: scenes.length > 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 961,
        settings: {
          slidesToShow: 1,
          infinite: scenes.length > 1,
          slidesToScroll: 1,
        },
      },
    ],
  };


  return (
    <div className="scenes-panel">
      <Slider {...settings}>
        {scenes.map((scene) => (
          <div key={scene._id}>
            <div className="ui-materials">
              <div className="e-card-scene">
                <img
                  className="card-banner"
                  src={scene.bannertopUrl}
                  alt={scene.title}
                />
                <div className="card-body">
                  <p className="card-createdby">Creado por: Educa360</p>
                  <div className="card-circles">
                    {scene.category?.map((cat) => (
                      <div
                        key={cat}
                        className={`circle ${getCircleColorClass(cat)}`}
                      />
                    ))}
                    {scene.subcategory && (
                      <h4 className="card-subcategorie">
                        {scene.subcategory.join(", ")}
                      </h4>
                    )}
                  </div>
                  <h3 className="card-title">{scene.title}</h3>
                  <hr className="card-divider" />
                  <div className="card-actions">
                    <button
                      className="btn-add-route"
                      onClick={() => handleEnter(scene)}
                    >
                      <Icon name="sign-in" /> Entrar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}
